/**
 * OCP-930 - a sensitive read (decrypted secrets, bulk personal data:
 * lib/operator-roles.ts SENSITIVE_READS in the api) answers only a
 * super_admin person with a verified second factor, and only with a `reason`
 * (at least 10 characters) that the api audits with the call.
 *
 * The exports are plain GET downloads the browser handles (Content-
 * Disposition), so the reason travels as the `reason` query parameter.
 * Returns the URL to open, or null when the operator gave no usable reason.
 */
export const SENSITIVE_READ_REASON_MIN = 10;

export function sensitiveReadUrl(url: string, what: string): string | null {
  const reason = window.prompt(
    `${what} is a sensitive read: a super_admin person with a second factor only, and the reason is audited with the download. Why do you need it?`,
  );
  if (reason === null) return null;
  if (reason.trim().length < SENSITIVE_READ_REASON_MIN) {
    window.alert(`The reason needs at least ${SENSITIVE_READ_REASON_MIN} characters.`);
    return null;
  }
  return `${url}${url.includes('?') ? '&' : '?'}reason=${encodeURIComponent(reason.trim())}`;
}
